// Keep the mobile import path stable while sharing the authoritative helper
// with the API notification and game-state code.
export { isPlayerResigned, resignedSlotIds } from '@warcarp/api-types'
export type { PlayerStatusSource } from '@warcarp/api-types'
